import { render, staticRenderFns } from "./AdminerPage.vue?vue&type=template&id=016deb48&"
import script from "./AdminerPage.vue?vue&type=script&lang=js&"
export * from "./AdminerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports